export default "__VITE_ASSET__ce19824c__"